import React, { JSX, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Store } from '../store';
import Style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = (): JSX.Element => {
  const { globalState } = useContext(Store);
  const breadcrumbs = globalState.breadcrumbs;

  return (
    <div className="c-breadcrumb">
      <div className="c-breadcrumb__inner">
        <ul>
          <li>
            <a href="https://help.sakura.ad.jp">
              <span>トップ</span>
            </a>
          </li>
          {breadcrumbs.map((breadcrumb, i) => {
            return (
              <li key={i}>
                <Link to={breadcrumb.path} className={breadcrumbs.length - 1 === i ? Style.last : undefined}>
                  <span>{breadcrumb.text}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default Breadcrumbs;
